import 'i18next';
import { IsEmail, IsNotEmpty } from 'class-validator';

import { t } from '@app-velocity/i18n';

export class TeamMemberDto {
  @IsEmail({}, {
    message: t('teams:validation.member_email_invalid'),
  })
  email = '';

  @IsNotEmpty({
    message: t('teams:validation.member_role_required'),
  })
  role = '';
}
